
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
// Register $ global var for jQuery
/*import $ from 'jquery';
window.$ = window.jQuery = $;*/

// Import jQuery Plugins
import 'owl.carousel/dist/owl.carousel.js';
import 'magnific-popup/dist/jquery.magnific-popup.min.js';
import 'swiper/dist/js/swiper.js';

window.moment = require('moment');
window.moment.locale('es');

/*var Masonry = require('masonry-layout/dist/masonry.pkgd.js');
var jQueryBridget = require('jquery-bridget');
jQueryBridget('masonry', Masonry, $);*/

import Headroom from 'headroom.js/dist/headroom.js';
window.Headroom = Headroom;
import 'headroom.js/dist/jQuery.headroom.js';

import 'sticky-kit/dist/sticky-kit.js';

import skrollr from 'skrollr/dist/skrollr.min.js';
window.skrollr = skrollr;

import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.js';
window.SmoothScroll = SmoothScroll;

import 'lavalamp/js/jquery.lavalamp.min.js';
import 'bootstrap-select/dist/js/bootstrap-select.min.js';
import 'bootstrap-select/js/i18n/defaults-es_ES.js';

import ClipboardJS from 'clipboard/dist/clipboard.min.js';
window.ClipboardJS = ClipboardJS;

window.Swal = require('sweetalert2/dist/sweetalert2');

import 'jquery-toast-plugin/dist/jquery.toast.min.js';
import 'jquery-validation/dist/jquery.validate.min.js';
import '../plugins/jquery-validation/lessThanToday.js';
import '../plugins/jquery-validation/minDate.js';
import 'jquery-validation/dist/localization/messages_es.min.js';
import 'prismjs/prism.js';
import 'prismjs/plugins/toolbar/prism-toolbar.js';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard.min.js';
/*import 'node_modules/video.js/dist/video.js';
import 'node_modules/videojs-youtube/dist/Youtube.js';*/
//import 'modernizr/bin/modernizr';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.es.min.js';
import 'jquery-form/dist/jquery.form.min';

import '../plugins/jquery.passwordstrength.js';
import '../plugins/responsive-calendar/0.9/js/responsive-calendar';



import Dropzone from 'dropzone/dist/dropzone.js';
Dropzone.autoDiscover = false;
window.Dropzone = Dropzone;

//PDF OBJECT
window.PDFObject = require('pdfobject/pdfobject');

import './init';
import './employee';
import './procedure';
import './enterprise';
import './reports';
import './user';
import './gallery';
import './reservation';
import './timer';
import './agenda';


